module.exports = __webpack_public_path__ + "static/img/pagebottomPng.57de0fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pagebottomPng.png
// module id = EWq6
// module chunks = 1